import { render, staticRenderFns } from "./MesaPagoComponent.vue?vue&type=template&id=a6224038"
import script from "./MesaPagoComponent.vue?vue&type=script&lang=js"
export * from "./MesaPagoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports